"use client"
import {
  springEasing,
  transitionEase,
  transitionTime,
  transitionUpValue,
} from "./utils"

export const useTransitionUpStyles = (
  $inView: boolean,
  $delay?: number,
  $time?: number,
  $easing?: keyof typeof springEasing,
) => {
  const easingValue = $easing ? springEasing[$easing] : transitionEase

  return {
    PointerEvent: "auto",
    opacity: $inView ? 1 : 0,
    transition: `all ${$time ? $time : transitionTime}s ${easingValue}`,
    transform: $inView ? "translateY(0px)" : `translateY(${transitionUpValue})`,
    ...(typeof $delay === "number" && { transitionDelay: `${$delay}s` }),
  }
}
